export const comments_3903059 = {"data":{"data":[],"links":{}}}